export class LabsDashboardRevenueModel {
    labName: string;
    labTotalPercentage: string;
    grandTotal: number;
    labTotal: number;
}
